@let errorMessage = errorMessage$ | async;

@if (errorMessage) {
  <p class="form-error">
    {{ errorMessage }}
  </p>
}
